exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".product-info{border-top:1px solid #eee;width:100%;overflow:hidden}.product-info img,.product-info video{width:100%!important;height:auto!important;vertical-align:bottom}", "", {"version":3,"sources":["/Users/zhouzhuang/software/IdeaProjects/cartx/web/shop/src/components/detail/product-info.vue"],"names":[],"mappings":"AACA,cACI,0BAA2B,AAC3B,WAAY,AACZ,eAAiB,CACpB,AACD,sCAEI,qBAAuB,AACvB,sBAAwB,AACxB,qBAAuB,CAC1B","file":"product-info.vue","sourcesContent":["\n.product-info {\n    border-top: 1px solid #eee;\n    width: 100%;\n    overflow: hidden;\n}\n.product-info img,\n.product-info video {\n    width: 100% !important;\n    height: auto !important;\n    vertical-align: bottom;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-57cdcdf7","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/detail/product-info.vue
// module id = KqOm
// module chunks = 1